module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ./~/axios/index.js
// module id = 64
// module chunks = 7132574359420 35783957827783 70144966829960